import {getRefreshToken, getTokenFromSession, refreshIdToken} from "../services/authenticate";
import {api} from "../api";
import axiosInstance from "../axiosInstance";

export const getStockDetailsUsingStockId = async ({stockId}) => {
    const token = getTokenFromSession();
    try {
        return await axiosInstance.get(`${api.stock}`, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `${token}`,
            },
            params: {stockId},
        });
    } catch (error) {
        if (error.response?.status === 401 || error.response?.status === 403) {
            const refreshToken = getRefreshToken();
            try {
                sessionStorage.setItem("intendedPage", "/stockSearch");
                if (!refreshToken) {
                    alert("Session expired. Please log in again.");
                    window.location.href = "/";
                    return;
                }
                await refreshIdToken(refreshToken);
                return await getStockDetailsUsingStockId({stockId}); // ✅ return result of retry
            } catch (refreshError) {
                window.location.href = "/";
            }
        } else {
            throw error;
        }
    }
};


export const postStockDataAndBookData = async ({data}) => {
    const token = getTokenFromSession();
    try {
        return await axiosInstance.post(`${api.stock}`, data, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `${token}`,
            },
        })
    } catch (error) {
        if (error.response?.status === 401 || error.response?.status === 403) {
            const refreshToken = getRefreshToken();
            try {
                sessionStorage.setItem("intendedPage", "/stockSearch");
                if (!refreshToken) {
                    alert("Session expired. Please log in again.");
                    window.location.href = "/";
                    return;
                }
                await refreshIdToken(refreshToken);
                return await postStockDataAndBookData({data});
            } catch (refreshError) {
                window.location.href = "/";
            }
        } else {
            throw error;
        }
    }
}